import React, { useState } from "react";
import colors from "../../../share/constants/constants";
import Button from "../../../components/common/button";
import { Link } from "react-router-dom";
import Yupup from "./../../../assets/icons/newLogo.png";
import YupupScreen from "./../../../assets/icons/blackLogo.svg";
import HeroImage from "../../../components/common/HeroImage";
import { Form, Input as InputField, message } from "antd";
import Checkbox from "../../../components/common/checkBox";
import { login } from "../../../api/auth";
import { setToken, clearLocalStorage } from "../../../authService";
import { useNavigate } from "react-router-dom";
import { getUser } from "../../../api/user";

const Login = () => {
  const [flag, setFlag] = useState(true);
  const [loader, setLoader] = useState(false);
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoader(true);
    const res = await login({ email: values.email, password: values.password });

    if (res) {
      // Temporarily set token so getUser can authenticate
      setToken(res.accessToken, res.refreshToken);
      localStorage.setItem("email", values.email);

      const userRole = await getUser();

      // Admin users may not have role returned; reject USER, GUEST, BUSINESS_OWNER, BUSINESS_MEMBER
      const nonAdminRoles = ["USER", "GUEST", "BUSINESS_OWNER", "BUSINESS_MEMBER"];
      const isNonAdmin = nonAdminRoles.includes(userRole?.role);
      if (isNonAdmin) {
        // Don't store token for non-ADMIN - clear and stay on login
        clearLocalStorage();
        message.error("Unauthorized - Admin access only");
      } else {
        message.success("Login Successful");
        navigate("/main/dashboard");
      }
    }
    setLoader(false);
  };

  const onFinishFailed = () => {};

  return (
    <div className="flex flex-col justify-center items-center h-screen overflow-y-hidden bg-primaryPurple lg:bg-white lg:pt-0 lg:grid lg:grid-cols-2 lg:content-center xl:grid xl:grid-cols-2 xl:content-center xl:pt-0 2xl:grid 2xl:grid-cols-2 2xl:content-center 2xl:pt-0">
      <div className="flex flex-col items-center justify-center h-screen">
        <div className="object-cover flex flex-row justify-center ">
          <img
            className="block sm:block md:block lg:hidden xl:hidden h-18"
            alt="yupup-logo"
            src={Yupup}
          />
        </div>
        <div className="object-cover">
          <img
            className="hidden sm:hidden md:hidden lg:block xl:block xl:h-15.3 "
            alt="yupup-screen-logo"
            src={YupupScreen}
          />
        </div>
        <div className="hidden sm:hidden md:flex text-white md:mt-8 lg:flex lg:text-black xl:flex flex-col justify-start w-40 xl:text-black xl:mt-0 xl:space-y-0 ">
          <p className="text-xl font-bold">Hello, Admin</p>
          <p className="text-lg font-normal">Log In To Admin Dashboard</p>
        </div>
        <div className="flex flex-col items-center lg:items-start xl:items-start">
          <div className="flex w-31 justify-start mt-5 md:w-40 md:mt-0 lg:mt-0 xl:mt-0">
            <p className="text-white block xl:hidden">Login</p>
          </div>
          <div className=" flex flex-col items-center mb-2 space-y-4 xl:mt-6 xl:mb-6">
            <Form
              form={form}
              className=""
              name="signin"
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Form.Item
                name="email"
                rules={[
                  {
                    type: "email",
                    message: "The input is not valid E-mail!",
                  },
                  {
                    required: true,
                    message: "Please input your E-mail!",
                  },
                ]}
              >
                <InputField
                  className={
                    flag
                      ? "w-31 bg-inputFieldGrey hover:border-primaryBlue h-5.4 sm:w-31 md:w-40 lg:w-40 xl:w-40 "
                      : "w-31 hover:border-primaryBlue h-5.4 border-primaryBlue sm:w-31 md:w-40 lg:w-40 xl:w-40 "
                  }
                  placeholder="Email"
                  onBlur={() => {
                    setFlag(true);
                  }}
                  onFocus={() => {
                    setFlag(false);
                  }}
                />
              </Form.Item>
              <Form.Item
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Please input your password!",
                  },
                ]}
              >
                <InputField.Password
                  className={
                    flag
                      ? "input-password w-31 h-5.4 bg-inputFieldGrey hover:border-primaryBlue sm:w-31 md:w-40 lg:w-40 xl:w-40 "
                      : "input-password-onfocus h-5.4 hover:border-primaryBlue border-primaryBlue w-31 sm:w-31 md:w-40 lg:w-40 xl:w-40"
                  }
                  placeholder="Password"
                  onBlur={() => {
                    setFlag(true);
                  }}
                  onFocus={() => {
                    setFlag(false);
                  }}
                />
              </Form.Item>
              <div className="flex w-31 justify-between md:w-40 xl:w-40">
                <Form.Item name="remember">
                  <Checkbox
                    pstyle="text-white lg:text-black"
                    description="Remember me"
                  />
                </Form.Item>
                <Link to="/forgotpassword" className="no-underline">
                  <p className="text-primaryBlue">Forgot Password</p>
                </Link>
              </div>
              <Form.Item>
                <Button
                  title="Sign In"
                  color={colors.primaryBlue}
                  className="w-31 md:w-40 xl:w-40"
                  htmlType="submit"
                  loading={loader}
                />
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
      <div className="hidden lg:flex xl:flex w-full justify-end">
        <HeroImage />
      </div>
    </div>
  );
};

export default Login;
